import React from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';

import { useLanguage } from '../contexts/LanguageContext';

/**
 * Franja fija que avisa que esto es la demostración de PCM.
 *
 * 8 oct 2026 (Augusto: "el problema es que este demo no muestra
 * exactamente como se ve en PCM" -- se descartaron las maquetas y el demo
 * pasó a ser PCM de verdad, con una cuenta de ejemplo en solo lectura).
 *
 * Existe por dos razones que tiran en direcciones opuestas y las dos
 * importan:
 *
 * 1. Que nadie crea que está viendo SUS datos. Alguien que llega desde el
 *    sitio web a una aplicación llena de cuentas y saldos tiene que
 *    entender en el primer segundo que esos números son de ejemplo.
 * 2. Que entienda por qué no puede guardar nada ANTES de intentarlo. Un
 *    error al tocar "Guardar" se siente como una aplicación rota; un
 *    aviso de entrada se siente como una demostración.
 *
 * Y de paso es el único lugar del recorrido donde ofrecer crear una
 * cuenta sin interrumpir lo que la persona está mirando.
 */
const AvisoDemo = () => {
  const esDemo = useSelector((state) => state.auth.esDemo);
  const { language } = useLanguage();
  const isSpanish = language === 'es';
  const navigate = useNavigate();

  if (!esDemo) return null;

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar + 1,
        bgcolor: '#B8860B',
        color: '#fff',
        px: 2,
        py: 0.75,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        flexWrap: 'wrap',
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {isSpanish ? 'Estás viendo una demostración' : 'You are viewing a demo'}
      </Typography>
      <Typography variant="body2" sx={{ opacity: 0.92, flex: 1, minWidth: 220 }}>
        {isSpanish
          ? 'Los datos son de ejemplo. Puedes recorrer toda la aplicación; los cambios no se guardan.'
          : 'The data is sample data. You can explore the whole app; changes are not saved.'}
      </Typography>
      <Button
        size="small"
        onClick={() => navigate('/register')}
        sx={{
          bgcolor: '#fff',
          color: '#856108',
          fontWeight: 700,
          '&:hover': { bgcolor: '#f5efd4' },
        }}
      >
        {isSpanish ? 'Crear mi cuenta' : 'Create my account'}
      </Button>
    </Box>
  );
};

export default AvisoDemo;
